import request from './request'

export function getSysMessageList(data) {
  return request({
    url: '/api/sysMessage/list',
    method: 'get',
    params: data
  })
}
// 已读
export function sysMessageLook(data) {
  return request({
    url:'/api/sysMessage/look',
    method: 'get',
    params: data
  })
}
// 全部已读
export function sysMessageAllLook(data) {
  return request({
    url:'/api/sysMessage/allLook',
    method: 'get',
    params: data
  })
}
